import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {Col} from "react-bootstrap"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Creatable from 'react-select/lib/Creatable'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from 'react-day-picker/moment'
import moment from 'moment'
const BoxAddPurchase = ({item, units, ingredients, button, active, reset, onSelectIngredient, onChangeIngredient, onSelectUnit, onIngredientCreate, onSelectDate}) => {
    const id_unit_category = item.nameValue.id_unit_category;
    const ingredientUnits = units.map((itm, idx) => {
        const enabled = id_unit_category ? id_unit_category == itm.id_unit_category ? true : false : true;
        return <button
            key={idx}
            className={classnames("unit-button btn btn-theme", item.unitValue == itm.id ? "active" : "")}
            title={itm.name}
            onClick={enabled ? () => onSelectUnit(itm.id) : () => void(0)}
            disabled={!enabled}
        >
            {itm.unit}
        </button>
    })

    moment.locale('cs');

    return (
        <Col sm={12}>
            <div className="box no-hover vertical">
                <div className="box-content">
                    {
                        active ?
                            <div className="reset-box" onClick={reset} title="Zrušit">
                                <FontAwesomeIcon icon="times"/>
                            </div>
                            :
                            null
                    }
                    <div className="box-inputs">
                        <div className="ingredient-name">
                            <Creatable
                                key="select"
                                name="nameValue"
                                placeholder="Položka nákupu"
                                title="Položka nákupu"
                                value={item.nameValue}
                                isDisabled={item.nameValue.value == -1}
                                onChange={(e) => onSelectIngredient(e)}
                                options={ingredients}
                                className="react-select-container"
                                classNamePrefix="react-select"
                                onCreateOption={(e) => onIngredientCreate(e)}
                            />
                        </div>
                        <div className="ingredient-numeric">
                            <input
                                className="form-control"
                                type="number"
                                placeholder="Cena"
                                title="Cena"
                                value={item.priceValue}
                                onChange={(e) => onChangeIngredient(e)}
                                name="priceValue"
                                min="0"
                            />
                        </div>
                        <div className="ingredient-numeric">
                            <input
                                className="form-control"
                                type="number"
                                placeholder="Odpad"
                                title="Odpad"
                                value={item.wasteValue}
                                onChange={(e) => onChangeIngredient(e)}
                                name="wasteValue"
                                min="0"
                            />
                        </div>
                        <DayPickerInput
                            placeholder="Expirace"
                            title="Expirace"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            format="LL"
                            dayPickerProps={{
                                locale: 'cs',
                                localeUtils: MomentLocaleUtils,
                            }}
                            classNames={{container: "DayPickerInput ingredient-numeric", overlayWrapper:'DayPickerInput-OverlayWrapper', overlay:'DayPickerInput-Overlay'}}
                            value={item.expirationValue.nice ? moment(item.expirationValue.nice).format('LL') : ''}
                            onDayChange={(date) => typeof date !== 'undefined' ? onSelectDate(formatDate(date, 'YYYY-MM-DD'), date) : onSelectDate('', '')}
                        />
                        <div className="ingredient-numeric">
                            <input
                                className="form-control"
                                type="number"
                                placeholder="Množství"
                                title="Množství"
                                value={item.quantityValue}
                                onChange={(e) => onChangeIngredient(e)}
                                name="quantityValue"
                                min="0.1"
                                step="0.1"
                            />
                        </div>
                        <div className="ingredient-units">
                            {ingredientUnits}
                        </div>
                    </div>
                </div>
                <div className="box-icons-controls">
                    <div className="box-controls">
                        <div onClick={button.onClick}>{button.label}</div>
                    </div>
                </div>
            </div>
        </Col>
    );
}

BoxAddPurchase.propTypes = {
    ingredients: PropTypes.array.isRequired,
    units: PropTypes.array.isRequired,
    button: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    onSelectIngredient: PropTypes.func.isRequired,
    onChangeIngredient: PropTypes.func.isRequired,
    onSelectUnit: PropTypes.func.isRequired,
    onIngredientCreate: PropTypes.func.isRequired,
    onSelectDate: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
}

BoxAddPurchase.defaultProps = {
    units: [],
    ingredients: [],
}

export default BoxAddPurchase;